import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TwoColumnLayOut from "../../layouts/two-columns/two-column-layout";
import { retrieveEventDetails } from "../../redux/slice/events/event-details-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import { Link, useParams } from "react-router-dom";
import { retrieveTaxonomyEvent } from "../../redux/slice/taxonomy-event-slice";
import { retrieveEventRightSideBooks } from "../../redux/slice/right-side/event-right-side-books-slice";
import { retrieveEventRightSideLearning } from "../../redux/slice/right-side/event-right-side-learning-slice";
import { retrieveEventRightSideNews } from "../../redux/slice/right-side/event-right-side-news-slice";
import { retrieveEventRightSideRelatedEvents } from "../../redux/slice/right-side/event-right-side-related-events-slice";
import calenderIcon from "../../assets/images/icon-event-date.png";
import locationIcon from "../../assets/images/icon-event-location.png";
import { Helmet } from "react-helmet-async";
import LoadingComp from "../../components/re-usable/loading/loading";
import { useDynamicScripts } from "../../hooks/useDynamicScript";

//const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
//const daysNames = ["Mondays", "Tuesdays", "Wednesdays", "Thursdays", "Fridays", "Saturdays", "Sundays"];

const EventDetails = () => {
  const routeParams = useParams();
  const path = routeParams.path;
  const dispatch = useAppDispatch();
  const { EventDetailsData } = useSelector((state: RootState) => state.eventDetails);
  const { rightSideFeaturedBooksData } = useSelector((state: RootState) => state.EventRightSideBooks);
  const { rightSideFeaturedLearningData } = useSelector((state: RootState) => state.EventRightSideLearning);
  const { rightSideTrendingNewsData } = useSelector((state: RootState) => state.EventRightSideNews);
  const { rightSidePopularEventsData } = useSelector((state: RootState) => state.EventRightSideRelatedEvents);
  const { data } = useSelector((state: RootState) => state.taxonomyEvent);
  let eventDetails = EventDetailsData[0]?.eventInfoItemsList;
  const [pageTemplate, setPageTemplate] = useState<number>(1);
  const [hideBranding, setHideBranding] = useState<boolean>(false);
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  let detailPageNewsTrail = {
    trendingNewsData: rightSideTrendingNewsData,
    popularEventsData: rightSidePopularEventsData,
    featuredLearningData: rightSideFeaturedLearningData,
    featuredBooksData: rightSideFeaturedBooksData,
  };

  useEffect(() => {
    if (path) {
      dispatch(retrieveEventDetails(path));
      dispatch(retrieveTaxonomyEvent(path));
      dispatch(retrieveEventRightSideBooks(path));
      dispatch(retrieveEventRightSideLearning(path));
      dispatch(retrieveEventRightSideNews(path));
      dispatch(retrieveEventRightSideRelatedEvents(path));
    }
  }, [dispatch, path]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (EventDetailsData[0]?.eventInfoItemsList[0]?.hideRightRail)
      setPageTemplate(2)
    if (EventDetailsData[0]?.eventInfoItemsList[0]?.hideBranding)
      setHideBranding(true)
    if (eventDetails !== undefined) {
      setIsPublished(true);
    }

    const scriptField = EventDetailsData[0]?.eventInfoItemsList[0]?.script
    if (scriptField) {
      setScriptHtmlString(scriptField);
    }
  }, [EventDetailsData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "event-detail-script" });

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  const getDescription = (fullDesc: string) => {
    var shortDescription = fullDesc.replace("<br>", "").replace("<br/>", "");

    var descParts = fullDesc.split(/\r?\n|\r|\n/g)
    if (descParts.length > 1) shortDescription = descParts.slice(1).join(" ");

    return shortDescription;
  };

  return (
    <>
      <Helmet>
        <title>{EventDetailsData[0]?.eventInfoItemsList[0]?.isPublic ? EventDetailsData[0]?.pageTitle : ` | RAPS`}</title>
      </Helmet>
      <TwoColumnLayOut breadcrumbPath={`${path}`} isBreadcrumbpath={false} detailPageTaxonomy={data} detailPageNewsTrail={detailPageNewsTrail} showAds={true} isDetails={true} addSchema={true} schemaOptions={{ itemType: "https://schema.org/Event" }} pageTemplate={pageTemplate}>
        {(eventDetails?.length < 1) && "Event is not found"}
        {eventDetails &&
          eventDetails?.map((item, index) => {
            const startDate = formatDate(item.startDateTime)
            const endDate = formatDate(item.endDateTime)

            return item.isPublic ? (
              <div className="event-detail" key={index}>
                <div className="row">
                  <div className="col-xl-9 col-lg-12">
                    <div className="ed-header-wrapper">
                      <h1 itemProp="name" className="ed-header h1">{item.eventName}</h1>
                    </div>
                    <span className="ed-rac-wrapper">
                      {item.racCredits > 0 && (
                        <>
                          <div className="ed-rac-num">
                            <div className="ed-rac-num-inner">{item.racCredits}</div>
                          </div>
                          <span className="ed-rac-name" style={{ marginRight: "20px" }}>
                            RAC Credits
                          </span>
                        </>
                      )}
                      {item.badgeUrl && (
                        <div className="item-category">
                          <span className="category-type category-raps-event">
                            <span className="category-text d-flex flex-wrap" dangerouslySetInnerHTML={{ __html: item.badgeUrl }}></span>
                          </span>
                        </div>
                      )}
                    </span>

                    <div className="ed-top-wrapper">
                      <div className="ed-date-wrapper">
                        <div className="ed-date-icon">
                          <img src={calenderIcon} alt="calender icon" />
                        </div>
                        <div className="ed-date-text">
                          <meta itemProp="startDate" content={startDate} />
                          <meta itemProp="endDate" content={endDate} />
                          {item.formattedDate} {item.timeZone}
                        </div>
                      </div>
                      {item.streetAddress ? (
                        <div className="ed-location-wrapper">
                          {item.badgeUrl.includes("In-Person") && item.badgeUrl.includes("Virtual Programs")
                            ? (<meta itemProp='eventAttendanceMode' itemType='https://schema.org/MixedEventAttendanceMode' />) :
                            (item.streetAddress ?
                              <meta itemProp='eventAttendanceMode' itemType='https://schema.org/OfflineEventAttendanceMode' /> :
                              <meta itemProp='eventAttendanceMode' itemType='https://schema.org/OnlineEventAttendanceMode' />)
                          }
                          <div className="ed-location-icon">
                            <img src={locationIcon} alt="location icon" />
                          </div>
                          <div className="ed-location-text" itemProp="location" itemScope itemType="https://schema.org/Place">
                            <div>
                              <a
                                target="_blank"
                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.location.replace(/\s/g, "+"))}+${item.streetAddress.replace(/\s/g, "+")}+${item.city.replace(/\s/g, "+")}+${item.country.replace(/\s/g, "+")}+${item.postalCode}`}
                                rel="noopener noreferrer"
                              >
                                <span itemProp="name">{item.location}</span>
                              </a>
                            </div>
                            <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                              <div itemProp="streetAddress">{item.streetAddress}</div>
                              <div>
                                {item.city && (<><span itemProp="addressLocality">{item.city}</span>
                                  {(item.state || item.country || item.postalCode) && <>,&nbsp;</>}</>)}
                                {item.state && (<><span itemProp="addressRegion">{item.state}</span>{(item.country || item.postalCode) && <>,&nbsp;</>}</>)}
                                {item.country && (<><span itemProp="addressCountry">{item.country}</span>{item.postalCode && <>,&nbsp;</>}</>)}
                                {item.postalCode && <span itemProp="postalCode">{item.postalCode}</span>}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : <meta itemProp='location' itemType='https://schema.org/VirtualLocation' content='Virtual Program' />}
                    </div>
                  </div>

                  {item.sideImage && (
                    <div className="ed-header-img text-center col-xl-3 col-lg-12">
                      <img itemProp="image" alt={item.eventName} src={item.sideImage} style={{ marginLeft: "6px" }} />
                    </div>
                  )}
                </div>
                <div className="ed-table table-responsive"></div>
                {EventDetailsData[0]?.eventInfoItemsList[0]?.showRegisterBtn && (
                  <div className="ed-register-note ed-register" dangerouslySetInnerHTML={{ __html: EventDetailsData[0]?.eventInfoItemsList[0]?.registerButton }}></div>
                )}
                {item.note && (
                  <div className="ed-register-note-text">
                    <b>NOTE:</b> <span dangerouslySetInnerHTML={{ __html: item.note }} ></span>
                  </div>
                )}

                <div className="ed-content " id="edcontent" dangerouslySetInnerHTML={{ __html: EventDetailsData[0]?.eventInfoItemsList[0]?.longDescription }}></div>

                {item.uploadedFile && item.uploadedFileLinkText && (
                  <div className="ed-download">
                    <Link to={item.uploadedFile} download target="_blank">
                      {item.uploadedFileLinkText}
                    </Link>
                  </div>
                )}
                {item.uploadedFileTwo && item.uploadedFileTwoLinkText && (
                  <div className="ed-download">
                    <Link to={item.uploadedFileTwo} download target="_blank">
                      {item.uploadedFileTwoLinkText}
                    </Link>
                  </div>
                )}
                {item.uploadedFileThree && item.uploadedFileThreeLinkText && (
                  <div className="ed-download">
                    <Link to={item.uploadedFileThree} download target="_blank">
                      {item.uploadedFileThreeLinkText}
                    </Link>
                  </div>
                )}

                {EventDetailsData[0]?.eventInfoItemsList[0]?.showRegisterBtn && (
                  <div className="ed-content text-center" dangerouslySetInnerHTML={{ __html: EventDetailsData[0]?.eventInfoItemsList[0]?.registerButton }}></div>
                )}
                <span itemScope={true} itemProp="description" {...{ content: getDescription(item.shortDescription) }}></span>
              </div>
            ) : (
              "Event is not valid"
            );
          })}
        {hideBranding && <PartnerPageStyleComponent />}
      </TwoColumnLayOut>
    </>
  );
};

function formatDate(date: string) {
  var d = new Date(date)
  var year = d.toLocaleString("default", { year: "numeric" });
  var month = d.toLocaleString("default", { month: "2-digit" });
  var day = d.toLocaleString("default", { day: "2-digit" });

  return [year, month, day].join('-');
}

const PartnerPageStyleComponent = () => {
  return (
    <>
      <style>
        {`
          .header-top, .rosads, .site-footer, .navbar { display: none; }
        `}
      </style>
    </>
  )
};

export default EventDetails;
